export default class OpportunitySourceCategoryDomainService {
    static fromJSON(json) {
        return Object.assign({}, json);
    }
}
